import React, { useEffect, useRef, useState } from "react";
import { useInViewport } from "react-in-viewport";
import Text from "ab-text";
import Link from "ab-link";
import ParagraphText from "ab-paragraph-text";
import { getTranslation } from "ab-functions";
import Numeral from "numeral";
import { useTranslation } from "next-i18next";

import CardEBox from "./CardEBox";
import "./ab-cards-slider.scss";

const CardsSlider = ({
  title,
  text,
  cards = [],
  className = "",
  classname = "",
  link,
  animated,
  linkBefore,
  linkbefore,
  textStyle,
  i18n,
  navlink,
  product
}) => {
  const myRef = useRef();
  const esSinAlojamiento = !product?.configuradorEbox?.estancias?.length
  console.log("CardsSlider", product);
  const { t } = useTranslation();

  const precio = esSinAlojamiento && (product?.price || product?.producto?.price) ? Numeral(product?.price || product?.producto?.price).format("1,000[.]00$") : null
  const { inViewport, enterCount, leaveCount } = useInViewport(
    myRef,
    { threshold: 0.5 },
    {
      onEnterViewport: () => {
        // console.log("entered viewport");
      },
    },
    { disconnectOnLeave: false }
  );
  const handleScroll = () => {
    const element = document.getElementById(`menu-#${navlink}`);
    const menu = document.getElementById("history-menu");

    if (element) {
      if (inViewport) {
        if (!element?.classList?.contains("selected")) {
          const children = menu?.querySelectorAll("li");
          children.forEach(function (e) {
            if (e.id !== element.id) {
              e?.classList.remove("selected");
              e?.classList.add("not-selected");
            }
          });
          element?.classList.add("selected");
          element?.classList.remove("not-selected");
          menu.scrollLeft = element?.offsetLeft - 10;
        }
      } else {
        if (!element?.classList?.contains("not-selected")) {
          element?.classList.remove("selected");
          element?.classList.add("not-selected");
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [inViewport]);

  useEffect(() => {
    const slider = document.querySelector(`#cards-slider-${navlink}`);
    const cardsContainer = document.querySelector(
      `#cards-container-${navlink}`
    );
    const myBar = document.querySelector(`#myBar-${navlink}`);
    const myBarContainer = document.querySelector(
      `#indicator-container-${navlink}`
    );

    // const circle = document.querySelector('#circle');

    let isDown = false;
    let startX;
    let scrollLeft;
    if (slider) {
      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
        slider.classList.remove("prevent-clic");
      });
      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        slider.classList.add("prevent-clic");

        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
        if (myBar && myBarContainer) {
          const percent =
            slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);

          const percentScroll = myBarContainer?.clientWidth;
          myBar.style.left = `${percent * percentScroll}px`;
        }
      });
      slider.addEventListener("mouseover", (e) => { });

      var computedStyle = getComputedStyle(cardsContainer);

      let elementWidth = cardsContainer.clientWidth; // width with padding

      elementWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
      console.log(navlink, elementWidth)
      console.log(navlink, slider?.scrollWidth)
      if (elementWidth >= slider?.scrollWidth) {
        myBarContainer.style.display = 'none'
        // alert(cardsContainer?.clientWidth)
        // setAttribute('display', 'none')
      }
    }
    // document.addEventListener('mousemove', (e) => {

  }, [navlink]);
  return (<>
    <a className="reference" style={{ top: -100 }} id={navlink} />

    <div className={`ab-cards-slider ${className || ""} ${classname || ""}`} id={`cards-container-${navlink}`} ref={myRef}>
      <div className="title">
        <Text element="h2" animated={animated} style={textStyle}>
          {title}
        </Text>
        {precio && navlink == 'que-incluye' ?
          <Text element="span" className="disponible gold" style={{
            alignSelf: 'center',
            fontSize: 20,
            fontFamily: "GT Eesti",
            fontWeight: 300
          }}>
            {`${t('total')} ${precio}`}
          </Text> : null}
      </div>
      {text ? <ParagraphText text={[text]} singleColumn /> : null}
      {link && (linkBefore || linkbefore) ? (
        <Link prefetch={false} {...link} className="before" />
      ) : null}
      <div className="row" id={`cards-slider-${navlink}`}>
        {cards.map((itm, index) => (<CardEBox
          src={itm?.src || itm?.image?.mediaItemUrl}
          srcSet={itm?.srcSet || itm?.imagemobile?.mediaItemUrl}
          label={itm?.label}
          title={itm?.title}
          description={itm.description}
          href={
            getTranslation({ link: itm.page }, "uri", {
              code: i18n.language.toUpperCase(),
            }) || itm.href
          }
          key={`cross-card-${index}`}
          link={itm?.link}
          cardsLength={navlink == 'alojamiento' ? 3 : cards?.length}
          index={index}
        />))}

        <div
          className="scroll-indicator"
          id={`indicator-container-${navlink}`}
        >
          <div className="scroll-indicator-bar" id={`myBar-${navlink}`}></div>
        </div>
      </div>
    </div>
  </>
  );
};

export default CardsSlider;
